import React from "react";

import { Link } from "react-router-dom";

import "./MerchTeaser.scss";

export const MerchTeaser = () => {
  return (
    <section className="merch-teaser">

      <div className="merch-teaser-inner">

        <div className="merch-meta">
          <span>06</span>
          <small>MERCH / OBJECTS</small>
        </div>

        <div className="merch-main">

          <h2>
            THE UNIVERSE
            <span>YOU CAN WEAR.</span>
          </h2>

          <div>

            <p>
              LHANGAR merchandise is being
              built as an extension of the
              artistic universe — not simply
              products, but objects carrying
              the identity of the movement.
            </p>

            <Link to="/merch">
              EXPLORE MERCH
              <span>↗</span>
            </Link>

          </div>

        </div>

        <div className="merch-coming">

          <span>
            COMING
          </span>

          <span>
            SOON
          </span>

        </div>

      </div>

    </section>
  );
};